import { CalendarDaysIcon } from "@heroicons/react/24/outline";
import { lazy } from "react";

import type { FeatureMetadata } from "../../feature.types";

export const AcademicYearsFeature: FeatureMetadata = {
  id: "academic-years",
  moduleName: "academics",

  navigation: {
    label: "Academic Years",
    path: "/academic-years",
    icon: CalendarDaysIcon,
    order: 4,
  },

  route: {
    path: "/academic-years",
    element: lazy(() => import("./pages/AcademicYears")),
  },

  permissions: {
    view: "Academics.AcademicYearSetup.view",
    viewPrevious: "Academics.AcademicYearSetup.viewPrevious",
    create: "Academics.AcademicYearSetup.configure",
    edit: "Academics.AcademicYearSetup.edit",
    delete: "Academics.AcademicYearSetup.delete",
  },

  readiness: "live",
};
